import { useTranslation } from "react-i18next";

const Chapter = ({ onChapterProgressClick, data }) => {
  const { t } = useTranslation();
  const [videoProgress, index, initialVideosData, currentVideoId] = data;
  const [videoId, progressValue] = videoProgress;

  const isActive = currentVideoId === parseInt(videoId) ? "active" : "";
  return (
    <div className={`progress__chapter ${isActive}`}>
      <progress
        id={videoId}
        max="99"
        value={progressValue}
        onClick={onChapterProgressClick}
      />
      <div className="chapter__title">{t(initialVideosData[index]?.title)}</div>
    </div>
  );
};

export default Chapter;
